import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';
import AboutPageModel from 'models/AboutPage';
import PageTransition from 'containers/PageTransition';
import Head from 'components/Head';
import SlidingPageTransition from 'components/SlidingPageTransition';

import Link from 'next/link';
import Wrapper from './styled/Wrapper';
import ContentWrapper from './styled/ContentWrapper';
import Background from './styled/Background';
import BurgerMenu from './styled/BurgerMenu';
import BurgerButton from './styled/BurgerButton';
import CompanySection from './components/CompanySection';
import RecognitionSection from './components/RecognitionSection';
import TeamSection from './components/TeamSection';
import JobsSection from './components/JobsSection';
import ContactSection from './components/ContactSection';
import SecondaryFooter from './styled/SecondaryFooter';
import TopButton from './styled/TopButton';
import HomeButton from './styled/HomeButton';

export default class AboutPage extends PureComponent {
  constructor(props) {
    super(props);

    const {
      companySectionTitle,
      recognitionSectionTitle,
      teamSectionTitle,
      careerSectionTitle,
      contactSectionTitle,
    } = this.props;

    this.myRefs = {
      [companySectionTitle]: createRef(),
      [recognitionSectionTitle]: createRef(),
      [teamSectionTitle]: createRef(),
      [careerSectionTitle]: createRef(),
      [contactSectionTitle]: createRef(),
    };

    this.rootRef = createRef();
  }

  static defaultProps = {
    topOffset: 100,
  };

  static contextType = ThemeContext;

  state = {
    isMenuVisible: false,
    isTopVisible: false,
  };

  onBurgerClick = () => {
    const { isMenuVisible } = this.state;
    this.setState({ isMenuVisible: !isMenuVisible });
    // if(appState.analytics)appState.analytics._trackEvent('AboutPage', 'click burger');
  };

  onTopClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // if(appState.analytics)appState.analytics._trackEvent('AboutPage', 'click top');
  };

  onScroll = scrollY => {
    const { topOffset } = this.props;

    this.setState({ isTopVisible: scrollY > topOffset });
  };

  getSectionComponent = (sections, name) => {
    return sections.find(section => section.title === name);
  };

  componentDidMount() {
    if (!window.location.search) return;
    const refs = this.myRefs;
    const props = this.props;

    const searchQuery = window.location.search.replace('?', '');
    let domNodeToScroll;

    switch (searchQuery) {
      case 'company':
        domNodeToScroll = props.companySectionTitle;
        break;
      case 'recognition':
        domNodeToScroll = props.recognitionSectionTitle;
        break;
      case 'team':
        domNodeToScroll = props.teamSectionTitle;
        break;
      case 'career':
        domNodeToScroll = props.careerSectionTitle;
        break;
      case 'contact':
        domNodeToScroll = props.contactSectionTitle;
        break;
      default:
        null;
    }

    if (domNodeToScroll === undefined) return;

    const domElement = refs[domNodeToScroll].current;

    domElement.scrollIntoView({ behavior: 'instant', block: 'start' });

    const obsverCallBack = entires => {};

    this.observer = new IntersectionObserver(obsverCallBack);

    Object.values(refs).forEach(value => this.observer.observe(value.current));
  }

  render() {
    const {
      ogTags,
      router,
      navLinks,
      companySectionHeading,
      companySectionTitle,
      companySectionParagraph1,
      companySectionParagraph2,
      recognitionSectionHeading,
      recognitionSectionTitle,
      recognitionSectionParagraph1,
      recognitionSectionParagraph2,
      awards,
      teamSectionHeading,
      teamSectionTitle,
      teamSectionParagraph1,
      featuredEmployees,
      employees,
      careerSectionHeading,
      careerSectionTitle,
      careerSectionParagraph1,
      careerSectionParagraph2,
      careerSectionEmail,
      careerSectionOpenPositionsHeading,
      openPositions,
      contactSectionHeading,
      contactSectionTitle,
      contactSectionParagraph1,
      contactSectionParagraph2,
      contactSectionEmail,
      footerLinkPrev,
      footerLinkNext,
    } = this.props;

    const { isMenuVisible, isTopVisible } = this.state;

    return (
      <>
        <Head ogTags={ogTags} router={router} />
        {/* <PageTransition router={router}  component={SlidingPageTransition} /> */}
        <Wrapper ref={this.rootRef} theme={this.context} dark={isMenuVisible}>
          <ContentWrapper hidden={isMenuVisible}>
            <Background blank />
            <CompanySection
              heading={companySectionHeading}
              title={companySectionTitle}
              paragraph1={companySectionParagraph1}
              paragraph2={companySectionParagraph2}
              childRef={this.myRefs[companySectionTitle]}
            />
            <RecognitionSection
              heading={recognitionSectionHeading}
              title={recognitionSectionTitle}
              paragraph1={recognitionSectionParagraph1}
              paragraph2={recognitionSectionParagraph2}
              awards={awards}
              childRef={this.myRefs[recognitionSectionTitle]}
            />
            <TeamSection
              heading={teamSectionHeading}
              title={teamSectionTitle}
              paragraph1={teamSectionParagraph1}
              featuredEmployees={featuredEmployees}
              employees={employees}
              childRef={this.myRefs[teamSectionTitle]}
            />
            <JobsSection
              heading={careerSectionHeading}
              title={careerSectionTitle}
              paragraph1={careerSectionParagraph1}
              paragraph2={careerSectionParagraph2}
              openPositionsHeading={careerSectionOpenPositionsHeading}
              email={careerSectionEmail}
              openPositions={openPositions}
              childRef={this.myRefs[careerSectionTitle]}
            />
            <ContactSection
              heading={contactSectionHeading}
              title={contactSectionTitle}
              paragraph1={contactSectionParagraph1}
              paragraph2={contactSectionParagraph2}
              email={contactSectionEmail}
              childRef={this.myRefs[contactSectionTitle]}
            />
            <SecondaryFooter
              prevLink={footerLinkPrev}
              nextLink={footerLinkNext}
              onTopButtonClick={this.onTopClick}
            />
            <Link href="/" passHref>
              <HomeButton />
            </Link>
          </ContentWrapper>
          <BurgerMenu
            router={router}
            items={navLinks}
            light={false}
            hidden={!isMenuVisible}
          />
          <BurgerButton
            isActive={isMenuVisible}
            light={!isMenuVisible}
            onClick={this.onBurgerClick}
          />
          <TopButton
            hidden={!isTopVisible || isMenuVisible}
            onClick={this.onTopClick}
          />
        </Wrapper>
      </>
    );
  }
}
